(function () {
  'use strict';

  var dialog = null;
  var img = null;
  var prevBtn = null;
  var nextBtn = null;
  var closeBtn = null;
  var counter = null;
  var frame = null;
  var items = [];
  var index = 0;
  var scrollState = null;
  var bound = false;

  function lockPage() {
    if (scrollState) {
      return;
    }
    var scrollbar = window.innerWidth - document.documentElement.clientWidth;
    scrollState = {
      scrollY: window.scrollY,
      htmlOverflow: document.documentElement.style.overflow,
      bodyOverflow: document.body.style.overflow,
      bodyPosition: document.body.style.position,
      bodyTop: document.body.style.top,
      bodyWidth: document.body.style.width,
      bodyPad: document.body.style.paddingRight
    };
    document.documentElement.classList.add('cw-product-lightbox-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollState.scrollY + 'px';
    document.body.style.width = '100%';
    if (scrollbar > 0) {
      document.body.style.paddingRight = scrollbar + 'px';
    }
  }

  function unlockPage() {
    if (!scrollState) {
      return;
    }
    var scrollY = scrollState.scrollY;
    document.documentElement.classList.remove('cw-product-lightbox-open');
    document.documentElement.style.overflow = scrollState.htmlOverflow;
    document.body.style.overflow = scrollState.bodyOverflow;
    document.body.style.position = scrollState.bodyPosition;
    document.body.style.top = scrollState.bodyTop;
    document.body.style.width = scrollState.bodyWidth;
    document.body.style.paddingRight = scrollState.bodyPad;
    scrollState = null;
    window.scrollTo(0, scrollY);
  }

  function closeDialog() {
    if (dialog && dialog.open) {
      dialog.close();
    }
  }

  function shouldIgnoreBackdropClick(target) {
    if (!target || !target.closest) {
      return false;
    }
    return !!target.closest(
      '.cw-product-lightbox__frame, .cw-product-lightbox__img, .cw-product-lightbox__nav, [data-cw-lb-close]'
    );
  }

  function preventBackgroundScroll(e) {
    if (!dialog || !dialog.open) {
      return;
    }
    if (e.target && dialog.contains(e.target)) {
      return;
    }
    e.preventDefault();
  }

  function keepScrollLocked() {
    if (!dialog || !dialog.open || !scrollState) {
      return;
    }
    if (window.scrollY !== scrollState.scrollY) {
      window.scrollTo(0, scrollState.scrollY);
    }
  }

  function render() {
    if (!img || !items.length) {
      return;
    }
    if (index < 0) {
      index = 0;
    }
    if (index >= items.length) {
      index = items.length - 1;
    }
    var cur = items[index];
    img.src = cur.url;
    img.alt = cur.label || '';
    if (frame) {
      frame.classList.toggle('cw-product-lightbox__frame--personalized', !!cur.personalized);
    }
    img.classList.toggle('cw-product-lightbox__img--personalized', !!cur.personalized);
    var multi = items.length > 1;
    if (prevBtn) {
      prevBtn.hidden = !multi;
    }
    if (nextBtn) {
      nextBtn.hidden = !multi;
    }
    if (counter) {
      if (multi) {
        counter.hidden = false;
        counter.textContent = String(index + 1) + ' / ' + String(items.length);
      } else {
        counter.hidden = true;
        counter.textContent = '';
      }
    }
  }

  function bindLegacyDialogs() {
    ['cw-cart-lightbox', 'cw-order-design-lightbox'].forEach(function (legacyId) {
      var legacy = document.getElementById(legacyId);
      if (legacy && legacy.parentNode) {
        legacy.parentNode.removeChild(legacy);
      }
    });
  }

  function ensure() {
    bindLegacyDialogs();
    if (dialog) {
      return dialog;
    }
    dialog = document.getElementById('cw-product-lightbox');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.id = 'cw-product-lightbox';
      dialog.className = 'cw-product-lightbox';
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('aria-label', 'Powiększone zdjęcie');
      dialog.innerHTML =
        '<div class="cw-product-lightbox__wrap" data-cw-lb-wrap>' +
        '<div class="cw-product-lightbox__stage">' +
        '<button type="button" class="cw-product-lightbox__close" data-cw-lb-close aria-label="Zamknij">' +
        '<svg class="cw-product-lightbox__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
        '</button>' +
        '<button type="button" class="cw-product-lightbox__nav cw-product-lightbox__nav--prev" data-cw-lb-prev aria-label="Poprzednie zdjęcie" hidden>' +
        '<svg class="cw-product-lightbox__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>' +
        '</button>' +
        '<div class="cw-product-lightbox__frame">' +
        '<img class="cw-product-lightbox__img" src="" alt="" decoding="async" />' +
        '</div>' +
        '<button type="button" class="cw-product-lightbox__nav cw-product-lightbox__nav--next" data-cw-lb-next aria-label="Następne zdjęcie" hidden>' +
        '<svg class="cw-product-lightbox__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>' +
        '</button>' +
        '</div>' +
        '<p class="cw-product-lightbox__counter" data-cw-lb-counter hidden aria-live="polite"></p>' +
        '</div>';
      document.body.appendChild(dialog);
    }

    img = dialog.querySelector('.cw-product-lightbox__img');
    frame = dialog.querySelector('.cw-product-lightbox__frame');
    prevBtn = dialog.querySelector('[data-cw-lb-prev]');
    nextBtn = dialog.querySelector('[data-cw-lb-next]');
    closeBtn = dialog.querySelector('[data-cw-lb-close]');
    counter = dialog.querySelector('[data-cw-lb-counter]');

    if (bound) {
      return dialog;
    }
    bound = true;

    dialog.addEventListener('close', function () {
      unlockPage();
      if (img) {
        img.removeAttribute('src');
        img.alt = '';
      }
      items = [];
      index = 0;
    });
    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      closeDialog();
    });
    dialog.addEventListener('click', function (e) {
      if (shouldIgnoreBackdropClick(e.target)) {
        return;
      }
      closeDialog();
    });
    document.addEventListener('wheel', preventBackgroundScroll, { passive: false, capture: true });
    document.addEventListener('touchmove', preventBackgroundScroll, { passive: false, capture: true });
    window.addEventListener('scroll', keepScrollLocked, { passive: true, capture: true });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeDialog();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (items.length < 2) {
          return;
        }
        index = (index - 1 + items.length) % items.length;
        render();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (items.length < 2) {
          return;
        }
        index = (index + 1) % items.length;
        render();
      });
    }
    dialog.addEventListener('keydown', function (e) {
      if (!dialog.open) {
        return;
      }
      if (e.key === 'Escape') {
        e.preventDefault();
        closeDialog();
        return;
      }
      if (e.key === 'ArrowLeft' && prevBtn && !prevBtn.hidden) {
        prevBtn.click();
      } else if (e.key === 'ArrowRight' && nextBtn && !nextBtn.hidden) {
        nextBtn.click();
      }
    });

    return dialog;
  }

  function open(input, altsOrStart, maybeStart) {
    var normalized;
    if (Array.isArray(input) && input.length && typeof input[0] === 'object' && input[0] !== null && input[0].url) {
      normalized = {
        items: input.map(function (row) {
          return {
            url: String(row.url || ''),
            label: String(row.label || ''),
            personalized: !!row.personalized
          };
        }).filter(function (row) {
          return row.url !== '';
        }),
        index: typeof altsOrStart === 'number' ? altsOrStart : 0
      };
    } else {
      var urls = Array.isArray(input) ? input : [];
      var labels = Array.isArray(altsOrStart) ? altsOrStart : [];
      var start = typeof maybeStart === 'number' ? maybeStart : 0;
      normalized = {
        items: urls.map(function (url, idx) {
          return {
            url: String(url || ''),
            label: String(labels[idx] || '')
          };
        }).filter(function (row) {
          return row.url !== '';
        }),
        index: start
      };
    }

    if (!normalized.items.length) {
      return false;
    }
    ensure();
    if (!dialog || typeof dialog.showModal !== 'function') {
      window.open(normalized.items[0].url, '_blank', 'noopener');
      return false;
    }
    items = normalized.items;
    index = normalized.index;
    if (index < 0) {
      index = 0;
    }
    if (index >= items.length) {
      index = 0;
    }
    render();
    lockPage();
    dialog.showModal();
    if (closeBtn) {
      closeBtn.focus();
    }
    return true;
  }

  window.CustomWearProductLightbox = {
    open: open,
    close: closeDialog,
    ensure: ensure
  };
})();
